import { defineComponent, ref, nextTick, PropType } from 'vue';
import { ElMessage } from 'element-plus';
import { createDictionaryValue, updateDictionaryValue } from '@/api/system-config/index';
import { cloneDeep } from 'lodash-es';
import { IFormData } from './type.d';
import { DICTIONARY_CHANNEL_ENUM } from '@/constant';

export default defineComponent({
  emits: ['update:visible', 'success'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object as PropType<IFormData>,
    },
  },
  setup(props, { emit }) {
    const handleCloseDialog = () => {
      emit('update:visible', false);
    };

    const form = ref<IFormData>({
      dictValueId: '',
      dictCode: '',
      valueCode: '',
      value: '',
      sort: '',
      channel: '',
      remark: '',
      valueParentId: '',
      valueParentCode: '',
      senderCode: '',
    });
    const refForm = ref<any | null>(null);
    const handleOpenDialog = async () => {
      try {
        await nextTick();
        (refForm.value as any).resetFields();
        form.value.dictValueId = props.formData?.dictValueId || '';
        form.value.dictCode = props.formData?.dictCode || '';
        form.value.valueCode = props.formData?.valueCode || '';
        form.value.value = props.formData?.value || '';
        form.value.channel = props.formData?.channel || DICTIONARY_CHANNEL_ENUM.BACKGROUND;
        form.value.valueParentId = props.formData?.valueParentId || '';
        form.value.valueParentCode = props.formData?.valueParentCode || '';
        form.value.remark = props.formData?.remark || '';
        form.value.sort = props.formData?.sort || '';
        form.value.senderCode = props.formData?.senderCode || 'LY';
      } catch (e) {
        console.log(e);
      }
    };
    // 保存
    const handleSave = async () => {
      try {
        await nextTick();
        await (refForm.value as any).validate();
        const params = cloneDeep(form.value);
        if (form.value.dictValueId) {
          await updateDictionaryValue(params);
        } else {
          await createDictionaryValue(params);
        }
        ElMessage.success('更新成功！');
        handleCloseDialog();
        emit('success');
      } catch (err) {
        console.log(err);
      }
    };
    return {
      handleCloseDialog,
      handleOpenDialog,
      form,
      refForm,
      handleSave,
      rules: {
        valueCode: [
          {
            required: true,
            message: '编码不能为空',
          },
        ],
        value: [
          {
            required: true,
            message: '值不能为空',
          },
        ],
        sort: [
          {
            validator: (rules: any, value: string, callback: (err?: string) => void) => {
              if (value !== '') {
                const val = Number(value);
                if (Number.isNaN(val)) {
                  callback('排序必须为数字');
                } else if (val < 0) {
                  callback('排序值不能小于0');
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
          },
        ],
      },
    };
  },
  render() {
    return (
      <el-dialog
        title={this.form.dictValueId ? '编辑' : '新增'}
        modelValue={this.visible}
        onClose={this.handleCloseDialog}
        onOpen={this.handleOpenDialog}
        center
        width="500px"
        close-on-press-escape={false}
        close-on-click-modal={false}
        custom-class="dialog-width-medium el-dialog-inner-scroll"
        v-slots={{
          footer: () => (
            <div class="align-center">
              <el-button size="default" onClick={this.handleCloseDialog}>
                取 消
              </el-button>
              <el-button type="primary" size="default" onClick={this.handleSave}>
                保存
              </el-button>
            </div>
          ),
        }}
      >
        <el-form
          model={this.form}
          label-width="100px"
          style="width: 430px"
          size="default"
          rules={this.rules}
          ref="refForm"
        >
          <el-form-item label="字典值：" prop="value">
            <el-input v-model={this.form.value} />
          </el-form-item>
          <el-form-item label="编码：" prop="valueCode">
            <el-input v-model={this.form.valueCode} disabled={!!this.form.dictValueId} />
          </el-form-item>
          <el-form-item label="备注：">
            <el-input v-model={this.form.remark} />
          </el-form-item>
          <el-form-item label="排序：" prop="sort">
            <el-input v-model={[this.form.sort, ['number']]} />
          </el-form-item>
        </el-form>
      </el-dialog>
    );
  },
});
